var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4563 9.3435V16.7162L2.62427 22.3245H9.89214V22.5C9.89214 24.0253 11.3764 25.1105 13 25.1105C14.6237 25.1105 16.1079 24.0253 16.1079 22.5V22.3245H23.3757L22.2091 18.7532L22.1427 18.55L21.5432 16.7149V9.34351C21.5432 4.62509 17.7182 0.800049 12.9998 0.800049C8.28134 0.800049 4.4563 4.62508 4.4563 9.3435ZM20.6432 9.34351C20.6432 5.12214 17.2211 1.70005 12.9998 1.70005C8.77839 1.70005 5.3563 5.12214 5.3563 9.3435V16.8595L3.86507 21.4245H22.1349L21.4899 19.4501H7.37798V18.55H21.1959L20.6432 16.8582V9.34351ZM15.2079 22.3245H10.7921V22.5C10.7921 23.3632 11.6904 24.2105 13 24.2105C14.3096 24.2105 15.2079 23.3632 15.2079 22.5V22.3245Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellHover);
export default __webpack_public_path__ + "static/media/bell-hover.520e2b37.svg";
export { ForwardRef as ReactComponent };